import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { FDBodyText, FDDisplayText, FDHeadlineText } from '@facet-wealth/design';
import {
  TaxDiagnosticSummaryContainer,
} from 'Views/Page/Content/Templates/TaxDiagnosticTaxStrategiesSummaryStep/TaxDiagnosticSummaryContainer';

const metaOverrideSet = buildFacetDesignOverride()
  .nameOverride('title', {
    _component: () => FDDisplayText,
    _customProps: {
      color: 'textSecondary',
      align: 'center',
    },
  }, overrideReadOnly)
  .nameOverride('disclosure', {
    _component: () => FDBodyText,
    _customProps: {
      size: 'sm',
      align: 'center',
    },
  }, overrideReadOnly)
  .nameOverride('taxYearHeader', {
    _component: () => FDHeadlineText,
    _customProps: {
      size: 'sm',
      align: 'center',
    },
  }, overrideReadOnly)
  .nameOverride('description', {
    _component: () => FDBodyText,
    _customProps: {
      size: 'lg',
      align: 'center',
    },
  }, overrideReadOnly);

const Template = ({ resource }) => {
  return (
    <MetaResourceRenderer
      layout={TaxDiagnosticSummaryContainer}
      resource={resource}
      metaOverrideSet={metaOverrideSet}
    />
  );
};

Template.defaultProps = {
};

Template.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export default Template;
